import React from 'react'
import _ from 'lodash'
import {findDOMNode} from 'react-dom'

export class ScrollTrigger extends React.PureComponent {
  static defaultProps = {
    paddingFactor: 0 // % of the viewport height to pad the trigger area
  }

  constructor (props) {
    super(props)
    // not a state variable because it shouldn't trigger a re-render
    // and we need it to execute synchronously
    this._triggered = false
    this._throttledOnScroll = _.throttle(this.onScroll, 100)
  }

  componentDidMount () {
    this.onScroll()
    window.addEventListener('scroll', this._throttledOnScroll)
  }

  componentWillUnmount () {
    if (!this._triggered) {
      window.removeEventListener('scroll', this._throttledOnScroll)
    }
  }

  onScroll = () => {
    const {onScrollIntoView, paddingFactor} = this.props
    if (!this._ref) { return }
    const rect = findDOMNode(this._ref).getBoundingClientRect()

    const inTheDangerZone = (bound) => (
      bound < (window.innerHeight * (1 + paddingFactor)) &&
      bound > (window.innerHeight * -paddingFactor)
    )
    if (inTheDangerZone(rect.top) || inTheDangerZone(rect.bottom)) {
      this._triggered = true
      window.removeEventListener('scroll', this._throttledOnScroll)
      onScrollIntoView()
    }
  }

  setRef = (ref) => {
    this._ref = ref
  }

  render () {
    const props = _.omit(this.props, ['onScrollIntoView', 'paddingFactor'])
    return <div ref={this.setRef} {...props} />
  }
}

// handy dandy behavior tester
export class ScrollTriggerTest extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {triggered: false}
  }

  reset = () => this.setState({triggered: false})
  onTrigger = () => this.setState({triggered: true})

  render () {
    const {triggered} = this.state
    return <div style={{background: triggered ? '#F06292' : '#B0BEC5'}} onClick={this.reset}>
      <div style={{height: 2000}} />
      {triggered
        ? <div style={{background: '#B2EBF2'}}>ScrollTrigger</div>
        : <ScrollTrigger style={{background: '#B2EBF2'}} onScrollIntoView={this.onTrigger}>
          ScrollTrigger
        </ScrollTrigger>
      }
      <div style={{height: 2000}} />
    </div>
  }
}
